import { Color } from "../enums/Color"
import { Font } from "../enums/Font"

export const recruiterMenu = {
    mobile: {
        topMenu: {
            position: "sticky",
            top: 0,
            display: "flex",
            flexDirection: "row" as "row",            
            height: "16.67vw",
            background: Color.DeepBlack,
            padding: "4.83vw",
            transparent: {
                background: "transparent"
            }
        },   
        actions: {
            position: "sticky",
            background: Color.White,
            display: "flex",
            flexDirection: "row" as "row",
            height: "16.18vw",
            borderBottom: "1px solid " + Color.Gainsboro,
            paddingRight: "4.83vw",
            alignItems: "center",
            lines: {
                width: "7.24vw",
                height: "11.35vw",
                borderRadius: "0 1.93vw 1.93vw 0",
                background: Color.DeepBlack,
                alignContent: "center",
                marginRight: "2.41vw",
                icon: {
                    width: "4.83vw",
                    height: "3.38vw"
                }
            },
            arrow: {
                display: "flex",
                width: "7.97vw",
                height: "7.97vw",
                borderRadius: "4.11vw",
                background: Color.LightAsh,
                alignItems: "center",
                justifyContent: "center",
                icon: {
                    height: "2.17vw",
                    transform: "rotate(270deg)"
                }
            },
            children: {
                marginLeft: "auto"
            }
        },
        mobileMenu: {
            label: {
                textDecoration: "none",
                fontSize: "4.34vw",
                fontWeight: "bold" as "bold",                
                color: Color.LightAsh
            },
            dropdownLabel: {
                position: "relative" as "relative",
                textDecoration: "none",
                fontSize: "4.4vw",
                fontWeight: "medium",
                color: Color.MiddleBlack
            },
            dropdownItem: {
                color: Color.MiddleBlack,
                fontWeight: "500",
                hover: {
                    padding: "1.38vw"
                },
                leave: {
                    padding: "1.38vw"
                }
            }
        },    
        wrapper: {
            display: "flex",
            position: "fixed",
            height: "100%",
            left: "0",
            flexDirection: "row" as "row",
            transition: "transform 0.3s ease-out",
            overflow: "hidden auto",
            zIndex: "4",
            open: {
                transform: "translateX(0)"
            },
            close: {
                transform: "translateX(-100%)"
            }
        },                                    
        leftWrapper: {
            display: "flex",
            flexDirection: "column" as "column",
            background: Color.DeepBlack,
            width: "77.29vw",
            height: "216.42vw"
        },
        rightWrapper: {
            width: "22.21vw",
            background: "rgba(0,0,0,0.5)",
            boxShadow: "1px 0px 7px rgba(0,0,0,0.5)",
            height: "216.42vw"           
        },        
        closeButton: {
            position: "absolute",
            top: "7.73vw",
            left: "73.22vw",
            width: "10.39vw",
            height: "19.56vw",
            borderRadius: "0 1.93vw 1.93vw 0",
            background: Color.DeepBlack
        },
        closeButtonIcon: {
            fill: Color.White,
            transform: "rotate(90deg)"
        },
        title: {
            display: "flex",
            justifyContent: "center",
            width: "67.63vw",
            height: "11.12vw",
            borderRadius: "0 0 2.90vw 2.90vw",
            background: Color.Blue,
            color: Color.White,
            margin: "0 auto",
            fontFamily: Font.Advanced,
            fontSize: "5.56vw",
            textAlign: "center",
            alignContent: "center",
            cursor: "pointer"
        },
        settingButtonIcon: {
            display: "none"            
        },
        logo: {
            width: "40.18vw",
            height: "4.00vw",
        },
        organization: {
            wrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                margin: "6.04vw 4.83vw 8.69vw 4.83vw"
            },
            logo: {
                width: "16.67vw",
                height: "16.67vw",
                borderRadius: "1.21vw",
                border: "1px solid " + Color.White                  
            },
            content: {
                width: "100%",
                marginLeft: "3.62vw",
                cursor: "pointer"
            },
            name: {
                display: "flex",
                justifyContent: "space-between",
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold",
                marginTop: "1.93vw",
                color: Color.White
            },
            detailWrapper: {
                display: "flex",
                fontSize: "2.66vw",
                color: Color.MiddleAsh,
                marginTop: "1.09vw",
                wordBreak: 'break-word'
            },
            organizationInfo: {
                maxWidth: "40vw"
            },
            detailText: {
                whiteSpace: "nowrap",
                overflow: 'hidden',
                textOverflow: "ellipsis",
                maxWidth: "62vw"
            },
            locationIcon: {
                height: "3.14vw",
                width: "2.90vw",
                fill: Color.Gainsboro,
                marginRight: "1.21vw"
            },
            userIcon: {
                height: "3.14vw",
                width: "5.31vw",
                fill: Color.Gainsboro,
                marginRight: "1.93vw"
            }
        },
        menu: {
            wrapper: {
                listStyleType: "none",                
                margin: "0 4.83vw",
                fontSize: "4.35vw",
                fontWeight: "bold" as "bold",
                color: Color.SharpAsh,
                padding: "0"
            },
            labelWrapper: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "8.45vw",
                width: "90%",
                borderRadius: "1.21vw",
                backgroundColor: "transparent",
                marginBottom: "2.41vw",
                padding: "0 4.83vw",
                cursor: "pointer",
                hovered: {
                    backgroundColor: Color.Blue,
                    color: Color.White,
                    marginBottom: "4.83vw",
                    border: "1px solid " + Color.Blue                    
                }
            },
            label: {
                textDecoration: "none",
                color: Color.SharpAsh
            },
            labelIcon: {
                fill: Color.SharpAsh,
                height: "2.16vw",
                width: "3.78vw",
                hovered: {
                    fill: Color.White,
                    transform: "rotate(180deg)"
                }
            },
            buttonWrapper: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            addButton: {
                height: "8.45vw",
                width: "11.365vw",
                borderRadius: "8.70vw",
                backgroundColor: Color.White,
                marginLeft: "4.83vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            addIcon: {
                height: "3.59vw",
                width: "3.59vw",
                fill: Color.Blue
            },
            hover: {
                display: "block",
                padding: "0 4.83vw 4.83vw 4.83vw",
                borderBottom: "1px solid " + Color.White,
                marginBottom: "4.83vw"
            },
            leave: {
                display: "none"
            },
            item: {
                fontSize: "4.35vw",
                fontWeight: "bold" as "bold",
                color: Color.SharpAsh,
                marginBottom: "1.93vw",
                fontFamily: Font.Poppins,
                hover: {                    
                    color: Color.White
                },
                leave: {
                    color: Color.SharpAsh
                }
            },
            activeCircle: {
                display: "inline-flex",
                height: "1.93vw",
                width: "1.93vw",
                borderRadius: "0.97vw",
                backgroundColor: Color.Green,
                marginLeft: "2.05vw"
            }
        },
        quota: {
            wrapper: {
                height: "auto",
                width: "60.14vw",
                borderRadius: "2.41vw",
                backgroundColor: Color.Munsell,
                color: Color.White,
                margin: "auto auto 4.83vw auto",
                padding: "4.83vw 3.62vw 2.41vw 3.62vw"
            },
            row: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "2.41vw"
            },
            packageType: {
                width: "15.46vw",
                fontSize: "3.38vw"
            },
            packageValue: {
                fontSize: "4.35vw",
                fontWeight: "500"
            },
            quotaDetail: {
                fontSize: "2.66vw",
                fontWeight: "bold" as "bold"
            },
            progressBar: {
                position: "relative",
                height: "0.97vw",
                width: "100%",
                borderRadius: "3.62vw",
                border: "1px solid " + Color.White,
                margin: "-0.97vw 0 2.66vw 0"
            },
            progressFilter: {
                background: Color.Nyanza,
                height: "100%",
                borderRadius: "inherit",
                transition: "width .2s ease-in"
            },
            topUpButton: {
                height: "7.25vw",
                width: "100%",
                background: "transparent",
                borderRadius: "2.41vw",
                border: "2px solid " + Color.LightBlue,
                fontSize: "2.90vw",
                fontWeight: "bold" as "bold",
                color: Color.White,
                marginTop: "auto"
            },
            expiry: {
                width: "100%",
                height: "8.45vw",
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "left",
                justifyContent: "space-between",
            },
            expiryText: {
                fontSize: "2.66vw",
                fontWeight: "bold" as "bold"
            },
            expiryDate: {
                fontSize: "3.86vw",
                fontWeight: "500"
            },
            emptyWrapper: {
                height: "auto",
                width: "60.14vw",
                borderRadius: "2.41vw",
                backgroundColor: Color.Linen,
                color: Color.Red,
                margin: "auto auto 4.83vw auto",
                padding: "4.83vw",
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold",
                textAlign: "center"
            },
            purchaseButton: {
                height: "9.66vw",
                width: "100%",
                borderRadius: "2.41vw",
                backgroundColor: Color.Red,
                color: Color.White,
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold",
                marginTop: "3.86vw"
            }
        }                 
    },
    desktop: {   
        topMenu: {
            display: "none",
            open: {
                display: "none"
            }
        }, 
        actions: {
            display: "none"
        },
        wrapper: {
            display: "block",
            flexDirection: "unset",
            position: "relative",
            width: "fit-content",
            height: "auto",
            left: "auto",                  
            transition: "none",
            open: {
                transform: "none"
            },
            close: {
                transform: "none"
            }
        },
        leftWrapper: {
            width: "19.27vw",
            height: "53.125vw",
            borderRadius: "1.04vw"            
        }, 
        rightWrapper: {
            display: "none"
        },       
        title: {
            width: "17.18vw",
            height: "2.86vw",
            borderRadius: "0 0 0.625vw 0.625vw",
            paddingTop: "0.52vw",
            fontSize: "1.46vw"
        },  
        settingButtonIcon: {
            display: "block",
            width: "0.99vw",
            height: "0.99vw", 
            position: "absolute",
            right: 0,
            marginRight: "1.04vw"
        },          
        logo: {
            width: "10.18vw",
            height: "1.56vw",
        },
        organization: {
            wrapper: {
                margin: "1.04vw 1.05vw 2.60vw 1.05vw"
            },
            logo: {
                width: "4.17vw",
                height: "4.17vw",
                borderRadius: "0.52vw"                
            },
            content: {
                marginLeft: "1.03vw"
            },
            name: {
                fontSize: "1.04vw",
                fontWeight: "500",
                marginTop: "0.31vw"
            },
            detailWrapper: {
                fontSize: "0.78vw",                
                marginTop: "0.26vw"
            },
            organizationInfo: {
                maxWidth: "9.5vw",
                maxHeight: "2.8vw",
                overflow: "hidden"
            },
            locationIcon: {
                height: "0.94vw",
                width: "0.88vw",
                marginRight: "0.52vw"
            },
            userIcon: {
                height: "0.94vw",
                width: "1.56vw",
                marginRight: "0.52vw"
            }
        },
        menu: {
            wrapper: {               
                margin: "0 1.04vw",
                fontSize: "1.04vw"
            },
            labelWrapper: {
                height: "2.08vw",
                borderRadius: "0.26vw",
                marginBottom: "0.52vw",
                padding: "0 1.04vw",
                hovered: {
                    marginBottom: "1.04vw"                   
                }
            },
            labelIcon: {
                height: "0.46vw",
                width: "0.81vw"
            },
            addButton: {
                height: "2.08vw",
                width: "2.648vw",
                borderRadius: "1.04vw",
                marginLeft: "0.68vw"
            },
            addIcon: {
                height: "0.88vw",
                width: "0.88vw"
            },
            hover: {
                padding: "0 1.28vw 1.04vw 1.28vw",
                marginBottom: "1.04vw"
            },
            item: {
                fontSize: "0.94vw",
                marginBottom: "0.42vw"                
            },
            activeCircle: {
                height: "0.42vw",
                width: "0.42vw",
                borderRadius: "0.21vw",
                marginLeft: "0.44vw"
            }
        },
        quota: {
            wrapper: {
                width: "auto",
                borderRadius: "0.78vw",
                margin: "auto 1.04vw 1.04vw 1.04vw",
                padding: "1.41vw 1.04vw 1.04vw 1.04vw"
            },
            row: {
                marginBottom: "0.625vw"
            },
            packageType: {
                width: "3.96vw",
                fontSize: "0.83vw",
                fontWeight: "bold" as "bold"
            },
            packageValue: {
                fontSize: "1.25vw"
            },
            quotaDetail: {
                fontSize: "0.73vw"
            },
            progressBar: {
                height: "0.36vw",
                borderRadius: "0.78vw",
                border: "1px solid " + Color.White,
                margin: "-0.36vw 0 1.09vw 0"
            },
            topUpButton: {
                width: "100%",
                height: "2.08vw",
                borderRadius: "0.52vw",
                fontSize: "0.83vw"
            },
            expiry: {
                height: "2.23vw"
            },
            expiryText: {
                fontSize: "0.73vw"
            },
            expiryDate: {
                fontSize: "1.04vw"
            },
            emptyWrapper: {
                width: "15.10vw",
                borderRadius: "0.78vw",
                margin: "auto auto 1.04vw auto",
                padding: "1.04vw",
                fontSize: "0.83vw"
            },
            purchaseButton: {
                height: "2.08vw",
                borderRadius: "0.52vw",
                fontSize: "0.83vw",
                marginTop: "0.83vw"
            }
        }       
    }
}
